import React, { useEffect, useRef, useState } from "react";
import ContentCard from "../contentcards/ContentCard";
import { Media } from "../../compilers/media";
import "../../stylesheet/components/catalogue/PaginatedList.scss";
import chevron from "../../assets/chevron.svg";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import Skeleton from "react-loading-skeleton";

type PaginatedListProps = {
  articles: Media[];
  currentPage: number;
  nextPage: () => void;
  previousPage: () => void;
  isFilterDropdownExpanded: boolean;
  section_type: string;
};

const PaginatedList: React.FC<PaginatedListProps> = ({
  articles,
  currentPage,
  nextPage,
  previousPage,
  isFilterDropdownExpanded,
  section_type,
}) => {
  const [paginatedMedia, setPaginatedMedia] = useState<Media[]>([]);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const { i18n, ready } = useTranslation();
  const lang = i18n.language;

  const getPageCount = () => {
    if (articles && articles.length) {
      const pageCount = Math.ceil(articles.length / 12);
      if (pageCount === 0) {
        return 1;
      }
      return pageCount;
    }
    return 1;
  };

  useEffect(() => {
    //scrollToTop();
    if (articles && articles.length) {
      if (currentPage === 1) {
        setPaginatedMedia(articles.slice(0, 12));
      } else if (currentPage === 2) {
        setPaginatedMedia(articles.slice(12, 24));
      } else {
        setPaginatedMedia(
          articles.slice((currentPage - 1) * 12, currentPage * 12)
        );
      }
    }
  }, [currentPage, articles]);

  function setColumnGrid() {
    if (window.innerWidth >= 1500) {
      listContainer.current?.style.setProperty(
        "grid-template-columns",
        "1fr 1fr 1fr"
      );
    } else if (window.innerWidth >= 768 && window.innerWidth < 1500) {
      listContainer.current?.style.setProperty(
        "grid-template-columns",
        "1fr 1fr"
      );
    } else {
      listContainer.current?.style.setProperty("grid-template-columns", "1fr");
    }
  }

  function SetMarginCardContainer() {
    if (lang == "en") {
      if (window.innerWidth > 1500) {
        listContainer.current?.style.setProperty("margin-left", "25.5%");
        listContainer.current?.style.removeProperty("margin-right");
      }
      if (window.innerWidth < 1500) {
        listContainer.current?.style.setProperty("margin-left", "34.25%");
        listContainer.current?.style.removeProperty("margin-right");
      }
      if (window.innerWidth <= 1150) {
        listContainer.current?.style.setProperty("margin-left", "0");
        listContainer.current?.style.removeProperty("margin-right");
      }
      setColumnGrid();
    } else if (lang == "ar") {
      if (window.innerWidth > 1500) {
        listContainer.current?.style.setProperty("margin-right", "25.5%");
        listContainer.current?.style.removeProperty("margin-left");
      }
      if (window.innerWidth < 1500) {
        listContainer.current?.style.setProperty("margin-right", "34.25%");
        listContainer.current?.style.removeProperty("margin-left");
      }
      if (window.innerWidth <= 1150) {
        listContainer.current?.style.setProperty("margin-right", "0");
        listContainer.current?.style.removeProperty("margin-left");
      }
      setColumnGrid();
    }
  }

  function HandleFilterOpenOnScreenResize() {
    window.onresize = SetMarginCardContainer;
  }

  // Setting up list container with Bootstrap class
  const listContainer = useRef<HTMLDivElement>(null);
  if (isFilterDropdownExpanded) {
    // ("Expanded");
    HandleFilterOpenOnScreenResize();
    SetMarginCardContainer();
  } else {
    /**
     * Removed the window.onresize function when
     * filter is not dropdown,
     * otherwise the function still there
     **/
    window.onresize = null;
    if (lang == "en") {
      listContainer.current?.style.removeProperty("margin-left");
      listContainer.current?.style.removeProperty("margin-right");
      listContainer.current?.style.removeProperty("grid-template-columns");
    } else if (lang == "ar") {
      listContainer.current?.style.removeProperty("margin-left");
      listContainer.current?.style.removeProperty("margin-right");
      listContainer.current?.style.removeProperty("grid-template-columns");
    }
  }

  return (
    <div className="list-outer">
      <div ref={listContainer} className="catalouge-wrapper">
        {paginatedMedia.map((article: Media) => {
          if (section_type === "academy") {
            article.data.bluePillText = article.data.difficulty ?? "";
            article.data.yellowPillText =
              article.data.learningPathways.length > 0
                ? article.data.learningPathways[0]
                : undefined;
            article.data.category = article.data.type;
          } else {
            article.data.bluePillText = article.data.type;
          }
          return (
            <div key={article.id} className="card-wrapper">
              <ContentCard media={article} section_type={section_type} />
            </div>
          );
        })}
      </div>
      <div className="pagination-buttons-container">
        <div
          className="d-flex"
          style={{
            margin: "0 1rem",
          }}
        >
          <div>{currentPage}</div>
          <div style={{ margin: "0 5px" }}>
            {ready ? `${t("button.of")}` : <Skeleton />}
          </div>{" "}
          <div>{getPageCount()}</div>
        </div>
        <button
          className={`p2 btn btn-square prev-btn ${
            currentPage === 1 ? "faint-yellow" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => {
            scrollToTop();
            previousPage();
          }}
        >
          <img className="chevron-back" src={chevron} alt="back" />
        </button>{" "}
        <button
          className={`p2 btn btn-square ${
            currentPage === getPageCount() ? "faint-yellow" : ""
          }`}
          disabled={currentPage === getPageCount()}
          onClick={() => {
            scrollToTop();
            nextPage();
          }}
        >
          <img className="chevron-next" src={chevron} alt="next" />
        </button>
      </div>
    </div>
  );
};

export default PaginatedList;
